function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

////////// Setup
var BASE_URL = '';
var RESPONSE_INTERCEPTOR = null;
export function setup(options) {
  if (typeof options.baseUrl === 'string') {
    BASE_URL = options.baseUrl;
  }

  if (typeof options.responseInterceptor === 'function') {
    RESPONSE_INTERCEPTOR = options.responseInterceptor;
  }
} ////////// Query Strings

export function parseUrl(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var url;

  if (options.external_url === true || path.match(/^https?:\/\//)) {
    url = path;
  } else {
    url = "".concat(BASE_URL, "/").concat(path.replace(/^\//, ''));
  }

  return url;
}
export function createUrlQueryString(object) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (object === null) {
    return '';
  } else if (Array.isArray(object)) {
    var keyName = "".concat(prefix, "[]");
    return object.map(function (aval) {
      return createUrlQueryString(aval, keyName);
    }).join('&');
  } else if (_typeof(object) === 'object') {
    return Object.keys(object).map(function (key) {
      var keyName;

      if (prefix.length > 0) {
        keyName = "".concat(prefix, "[").concat(key, "]");
      } else {
        keyName = key;
      }

      var oval = object[key];
      return createUrlQueryString(oval, keyName);
    }).join('&');
  } else {
    var _keyName = prefix;
    return "".concat(_keyName, "=").concat(encodeURIComponent(object));
  }
}
export function decodeUrlQueryString(query) {
  if (typeof query === 'string') {
    if (query.length === 0) {
      return {};
    }

    var object = {};
    var parts = query.split('&');
    parts.forEach(function (part) {
      var _part$split = part.split('='),
          _part$split2 = _slicedToArray(_part$split, 2),
          key = _part$split2[0],
          value = _part$split2[1];

      key = decodeURIComponent(key);
      value = decodeURIComponent(value);
      var keyParts = key.split('[').map(function (k) {
        return k.replace(']', '');
      });
      var partIndex = 0;
      var arrayValue = false;
      var valueObject = object;

      while (partIndex < keyParts.length - 1) {
        var _objectKey = keyParts[partIndex];
        var nextKey = keyParts[partIndex + 1];

        if (Array.isArray(valueObject)) {
          var arrayIndex = 0;

          while (typeof valueObject[arrayIndex] !== 'undefined' && typeof valueObject[arrayIndex][nextKey] !== 'undefined') {
            arrayIndex += 1;
          }

          valueObject[arrayIndex] = valueObject[arrayIndex] || {};
          valueObject = valueObject[arrayIndex];
          arrayValue = false;
        } else {
          if (nextKey === '') {
            valueObject[_objectKey] = valueObject[_objectKey] || [];
            arrayValue = true;
          } else {
            valueObject[_objectKey] = valueObject[_objectKey] || {};
            arrayValue = false;
          }

          valueObject = valueObject[_objectKey];
        }

        partIndex += 1;
      }

      var objectKey = keyParts[partIndex];

      if (arrayValue) {
        valueObject[objectKey] = valueObject[objectKey] || [];
        valueObject[objectKey].push(value);
      } else {
        valueObject[objectKey] = value;
      }
    });
    return object;
  } else {
    var _object = {};
    query.forEach(function (value, key) {
      _object[key] = value;
    });
    return _object;
  }
} ////////// Request

export function sendRequest(method, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var requestParams = [method, path, options];

  var handler = function handler(resolve, reject) {
    options.resolve = resolve;
    options.reject = reject;
    var headers = options.headers || {};
    var params = options.params || {};
    var includes = options.includes || [];
    var body = options.body || null;
    var files = options.files || null; ///// Path

    var url = parseUrl(path, options);
    method = method.toUpperCase(); ///// Params

    if (includes && includes.length > 0) {
      params.includes = includes;
    }

    if (files) {
      body = new FormData();
      Object.keys(files).forEach(function (fileKey) {
        body.append(fileKey, files[fileKey]);
      });
    } else if (Object.keys(params).length > 0 && !body) {
      switch (method) {
        case 'POST':
        case 'PUT':
          body = JSON.stringify(params);
          headers['Content-Type'] = 'application/json; charset=utf-8';
          break;

        case 'GET':
        default:
          url += "?".concat(createUrlQueryString(params));
      }
    } ///// Headers


    headers['X-Requested-With'] = 'XMLHttpRequest'; ///// XHR

    var xhr = new XMLHttpRequest();
    xhr.open(method, url);
    Object.keys(headers).forEach(function (key) {
      xhr.setRequestHeader(key, headers[key]);
    }); ///// Callbacks

    var handleResponse = function handleResponse() {
      var response = new Response(xhr);
      var interceptorCancelled = false;

      if (RESPONSE_INTERCEPTOR) {
        var interceptOptions = RESPONSE_INTERCEPTOR(response, requestParams) || {};

        if (interceptOptions.cancel) {
          interceptorCancelled = true;
        }
      }

      if (window.CustomEvent) {
        var event = new CustomEvent('jsapi:requestend', {
          cancelable: true,
          detail: [response, requestParams]
        });
        var eventCancelled = !document.dispatchEvent(event);

        if (interceptorCancelled || eventCancelled) {
          return;
        }
      } else {
        if (interceptorCancelled) {
          return;
        }
      }

      resolve(response);
    };

    xhr.onload = handleResponse;
    xhr.onerror = handleResponse;

    if (body) {
      xhr.send(body);
    } else {
      xhr.send();
    }
  };

  return new Promise(handler);
} ////////// Response

export var Response = /*#__PURE__*/function () {
  function Response(xhr) {
    _classCallCheck(this, Response);

    this._xhr = xhr;
    this.status = xhr.status;
    this.contentType = xhr.getResponseHeader('Content-Type');
    this.success = xhr.status >= 200 && xhr.status < 300;
    this.url = xhr.responseURL;

    if (this.contentType && this.contentType.indexOf(';') !== -1) {
      this.contentType = this.contentType.split(';')[0];
    }

    this.processContent();
  }

  _createClass(Response, [{
    key: "processContent",
    value: function processContent() {
      switch (this.contentType) {
        case 'application/json':
          this.content = JSON.parse(this._xhr.responseText);
          break;

        case 'text/html':
          {
            var html = document.createElement('html');
            html.innerHTML = this._xhr.responseText;
            this.content = html;
            break;
          }

        default:
          this.content = this._xhr.responseText;
          break;
      }
    }
  }]);

  return Response;
}();